import { ButtonToolbar, OverlayTrigger, Tooltip } from "react-bootstrap";

import { buttonTypeConstants, toastMessages } from "../../../constants";
import Button from "./Button";

const ButtonWithToolTip = (props) => {
  const {
    label,
    className,
    isDisabled = false,
    placement = "bottom",
    toolTipRootClassName,
    tooltipBody = toastMessages.NO_RECORD_FOUND,
    //all props that are in button component are passed down
  } = props;

  const tooltip = (
    <Tooltip id="tooltip-button" className="button-with-tooltip">
      {tooltipBody}
    </Tooltip>
  );
  return isDisabled && tooltipBody ? (
    <ButtonToolbar className={toolTipRootClassName}>
      {/* wrapper to avoid ref issues when disabled */}
      <OverlayTrigger placement={placement} overlay={tooltip}>
        {/* don't remove w-100 and manage the width in the toolTipRootClassName prop as width is controlled at parent level (<ButtonToolbar className={toolTipRootClassName}> level) and rest of the styling is passed down*/}
        <span className="w-100">
          <Button
            label={label}
            isDisabled={true}
            className={`${className} w-100`}
            buttonType={buttonTypeConstants.BLUE_BUTTON}
            {...props}
          />
        </span>
      </OverlayTrigger>
    </ButtonToolbar>
  ) : (
    <Button {...props} />
  );
};

export default ButtonWithToolTip;
